//
import React, { useState, useEffect, useContext, useRef } from "react";
import { Spin, Table } from "antdv5";
import { CheckOutlined, SendOutlined } from "@ant-design/icons";
import { registerLocale } from "react-datepicker";
import { addYears } from "date-fns";
import zhCN from "date-fns/locale/zh-CN";
import "react-datepicker/dist/react-datepicker.css";
import DefaultLayout from "components/layout/DefaultLayout";
import Container from "components/common/Container";
import useAPI from "components/customHook/useApi";
import ClubOpts from "components/common/ClubOpts";
import {
  ConnectText,
  Mask,
  Section,
  TableOutter,
} from "components/pages/DeviceOrder/DeviceOrder.style";
import OrderContent from "components/pages/DeviceOrder/OrderContent";
import { context } from "components/context/Context";

registerLocale("zh", zhCN);

const columns = [
  {
    title: "序号",
    dataIndex: "rank",
    width: 70,
  },
  {
    title: "踏板名称",
    dataIndex: "DeviceName",
    width: 120,
  },
  {
    title: "连线状态",
    dataIndex: "ClientStatus",
    width: 100,
    render: (text: string) => (
      <ConnectText link={text}>
        <div className="linkStatus">
          {Number.parseInt(text) === 1 ? "连线" : "离线"}
        </div>
      </ConnectText>
    ),
  },
  {
    title: "踏板ID",
    dataIndex: "DeviceUUID",
    width: 150,
  },
];
const testData = [
  {
    rank: "1",
    DeviceName: "John Brown1",
    id: "akgjhfeuhlkajg",
    ClientStatus: "连线",
  },
  {
    rank: "2",
    DeviceName: "John Brown2",
    id: "aegragfh",
    ClientStatus: "离线",
  },
  {
    rank: "3",
    DeviceName: "John Brown3",
    id: "adnriuhgakjbg",
    ClientStatus: "连线",
  },
  {
    rank: "4",
    DeviceName: "John Brown4",
    id: "afjekfnkj",
    ClientStatus: "离线",
  },
  {
    rank: "5",
    DeviceName: "John Brown4",
    id: "afjegdjnkj",
    ClientStatus: "离线",
  },
  {
    rank: "6",
    DeviceName: "John Brown4",
    id: "fefgrfnkj",
    ClientStatus: "离线",
  },
  {
    rank: "7",
    DeviceName: "John Brown4",
    id: "htha",
    ClientStatus: "离线",
  },
  {
    rank: "8",
    DeviceName: "John Brown4",
    id: "adbfbfnkj",
    ClientStatus: "离线",
  },
  {
    rank: "9",
    DeviceName: "John Brown4",
    id: "afjaagfnkj",
    ClientStatus: "离线",
  },
  {
    rank: "10",
    DeviceName: "John Brown4",
    id: "afjekfhyj",
    ClientStatus: "离线",
  },
  {
    rank: "11",
    DeviceName: "John Brown4",
    id: "afagehfnkj",
    ClientStatus: "离线",
  },
  {
    rank: "12",
    DeviceName: "John Brown4",
    id: "afjektjekfnkj",
    ClientStatus: "离线",
  },
];

const DeviceOrder = ({ fixedCurrentTime = false }) => {
  const { state } = useContext(context);
  const {
    preventRefreshCount,
    loading: spinLoading,
    handleAuth,
    clubList,
  } = useAPI();
  const [loading, setLoading] = useState(false);
  const [deviceName, setDeviceName] = useState<string[]>([]);
  const [show, setShow] = useState(false);
  const [send, setSend] = useState(true);
  const [getValue, setGetValue] = useState(1);
  const [orderContent, setOrderContent] = useState<string | null>(null);
  const currentTime = fixedCurrentTime
    ? new Date("2000-01-01T00:00:00")
    : new Date();
  const [startDate, setStartDate] = useState(currentTime);
  const [time, setTime] = useState(currentTime.getHours());
  const [min, setMin] = useState(currentTime.getMinutes());
  const datePickerRef = useRef();

  const fetchDevice = async () => {
    // why is this empty?
  };

  const handleSelection = (e: (string | number)[]) => {
    const selected = testData.filter((item) => e.includes(item.id));
    const selectedName = selected.map((d) => d.DeviceName);
    setDeviceName(selectedName);
  };
  const handleSubmit = () => {
    if (window.confirm(`发送时间为 ${time} 时 ${min} 分,确认发送?`)) {
      setShow(false);
      setOrderContent(null);
    }
    // unnecessary else
    // else {
    //   console.log("cancel submit");
    // }
    // commented in original code
    // setLoading(true);
  };
  useEffect(() => {
    handleAuth();
    if (localStorage.getItem("onAuth") === "true") {
      preventRefreshCount(fetchDevice, 5);
    }
  }, [state?.gid]);
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else if (!show) {
      document.body.style.overflow = "unset";
    }
  }, [show]);

  return (
    <DefaultLayout>
      <Mask show={show} onClick={() => setShow(false)} />
      <OrderContent
        show={show}
        send={send}
        min={min}
        time={time}
        startDate={startDate}
        deviceName={deviceName}
        datePickerRef={datePickerRef}
        getValue={getValue}
        orderContent={orderContent}
        setSend={setSend}
        setStartDate={setStartDate}
        setTime={setTime}
        setMin={setMin}
        setGetValue={setGetValue}
        setShow={setShow}
        setOrderContent={setOrderContent}
        addYears={addYears}
        handleSubmit={handleSubmit}
      />
      <Spin spinning={spinLoading} tip={"请等候3秒"}>
        <Container>
          <Section>
            <p className="para">
              <CheckOutlined /> 选择踏板
            </p>
            <ClubOpts clubList={clubList} />
          </Section>
          <TableOutter>
            <Table
              className="bordered-table"
              columns={columns}
              dataSource={testData}
              pagination={false}
              scroll={{ x: "max-content" }}
              rowKey="id"
              size={"small"}
              loading={loading}
              sticky
              bordered
              rowSelection={{
                onChange: handleSelection,
              }}
            />
            <div className="box">
              <div className="deviceNum">
                <p>已勾选 :</p>
                <p>{deviceName ? deviceName.length : "0"} 台</p>
              </div>
              <button
                className="sendOrder"
                disabled={deviceName.length <= 0}
                onClick={() => {
                  setShow(true);
                  handleAuth();
                }}
              >
                <SendOutlined /> 发送命令
              </button>
            </div>
          </TableOutter>
        </Container>
      </Spin>
    </DefaultLayout>
  );
};

export default DeviceOrder;
